import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_8 = { class: "table table-bordered" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = ["onClick"]

import { computed, toRef } from 'vue'
    import type { PanelDisagreementsReportReadModel } from '@Evaluation/AlternativesSurveys/Domain/readmodels'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DisagreementsReportDialog',
  props: {
    propOpened: { type: Boolean },
    propRm: {}
  },
  emits: ["show-question", "close-dialog"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const opened = toRef(props, 'propOpened')
    const rm = toRef(props, 'propRm')

    // ---------------- derived ----------------

    const questions = computed(() => rm.value?.Questions ?? [])

    // ---------------- methods ----------------

    function showQuestion(questionId: number)
    {
        emit('show-question', questionId)
    }

    function close()
    {
        emit('close-dialog')
    }

return (_ctx: any,_cache: any) => {
  return (opened.value === true)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Disagreements", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (!rm.value)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading... ", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (rm.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("table", _hoisted_8, [
                        _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Question"),
                            _createElementVNode("th", null, "Context"),
                            _createElementVNode("th", null, "Disagreement"),
                            _createElementVNode("th")
                          ])
                        ], -1 /* CACHED */)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (q) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: q.Id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(q.Title), 1 /* TEXT */),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", null, _toDisplayString(q.ContextName), 1 /* TEXT */),
                                (q.ContextPath)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_9, [
                                      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                      _createTextVNode(" Path: " + _toDisplayString(q.ContextPath), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(q.DisagreementStatus), 1 /* TEXT */),
                              _createElementVNode("td", _hoisted_10, [
                                _createElementVNode("a", {
                                  class: "text-primary",
                                  onClick: ($event: any) => (showQuestion(q.Id))
                                }, "show", 8 /* PROPS */, _hoisted_11)
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})